// Modes that send the user to the map screen to pick a location up-front.
const MODES_REQUIRING_LOCATION = new Set(["Centre visit"]);

export function modeRequiresLocation(modeName) {
  return MODES_REQUIRING_LOCATION.has(modeName);
}

// Modes where filtering providers by location means anything at all — the
// provider has to be somewhere the patient physically goes. A tele or video
// consultation happens over a call, so the provider's address is irrelevant to
// it and offering a location filter there is misleading.
//
// Mirrors zyla-app's LocationFilterConfig.isLocationFilterApplicable
// (lib/screens/service/utils/locationFilterConfig.dart), which allows exactly
// in-person, centre visit and camp visit.
//
// These strings are the backend's, verbatim — see MODE_* in
// api-services-service/models/constants.go (duplicated in
// api-appointment-service). Note "In person consultation" has no hyphen; this
// codebase used to spell it "In-person consultation", which never matched.
const MODES_ALLOWING_LOCATION_FILTER = new Set([
  "In person consultation",
  "Centre visit",
  "Camp site visit",
]);

export function isLocationFilterApplicable(modeName) {
  return MODES_ALLOWING_LOCATION_FILTER.has(modeName);
}
